import React from "react";

const KritikSaranStatusBadge = ({ status }) => {
  /*
  |--------------------------------------------------------------------------
  | STYLE
  |--------------------------------------------------------------------------
  */

  const style = {
    minWidth: "95px",
    fontWeight: "normal",
    letterSpacing: ".3px",
  };

  return (
    <>
      {/* DIKIRIM */}
      {status === "dikirim" && (
        <span
          className="badge bg-success"
          style={style}
        >
          <i className="fa fa-fw fa-paper-plane me-1" />
          Dikirim
        </span>
      )}

      {/* DIDISPOSISI */}
      {status === "didisposisi" && (
        <span
          className="badge bg-info text-dark"
          style={style}
        >
          <i className="fa fa-fw fa-share me-1" />
          Disposisi
        </span>
      )}

      {/* DIPROSES */}
      {status === "diproses" && (
        <span
          className="badge bg-warning text-dark"
          style={style}
        >
          <i className="fa fa-fw fa-spinner me-1" />
          Diproses
        </span>
      )}

      {/* SELESAI */}
      {status === "selesai" && (
        <span
          className="badge bg-primary"
          style={style}
        >
          <i className="fa fa-fw fa-circle-check me-1" />
          Selesai
        </span>
      )}

      {/* DITOLAK */}
      {status === "ditolak" && (
        <span
          className="badge bg-danger"
          style={style}
        >
          <i className="fa fa-fw fa-circle-xmark me-1" />
          Ditolak
        </span>
      )}

      {/* DEFAULT */}
      {![
        "dikirim",
        "didisposisi",
        "diproses",
        "selesai",
        "ditolak",
      ].includes(status) && (
        <span
          className="badge bg-dark"
          style={style}
        >
          <i className="fa fa-fw fa-question-circle me-1" />
          Unknown
        </span>
      )}
    </>
  );
};

export default KritikSaranStatusBadge;